import {Router} from '@angular/router';
import {ErrorStateService} from '../services/error-state/error-state.service';
import {HttpErrorResponse} from '@angular/common/http';
import {
  EMPTY,
  Observable,
  Subject,
  delay,
  finalize,
  from,
  of,
  switchMap,
  take,
  tap,
  throwError,
} from 'rxjs';
import {ErrorResponse} from '../interfaces/error-response';
import {ErrorStates} from '../interfaces/error-states';
import moment from 'moment';
import {RoutingEnum} from '../../../app/enums/routing.enum';

const errorMessageTransform = (error: ErrorResponse) => {
  const startTime = moment(error?.dataInizioBlocco);
  const startDate = startTime.format('DD/MM/YYYY');
  const startHour = startTime.format('HH:mm');

  const endTime = moment(error?.dataFineBlocco);
  const endDate = endTime.format('DD/MM/YYYY');
  const endHour = endTime.format('HH:mm');

  const toBeReplaced = [
    {in: startDate, out: '{{PLACEHOLDER_FROM_DATE}}'},
    {in: startHour, out: '{{PLACEHOLDER_FROM_TIME}}'},
    {in: endDate, out: '{{PLACEHOLDER_TO_DATE}}'},
    {in: endHour, out: '{{PLACEHOLDER_TO_TIME}}'},
  ];

  let errorMessage = error?.testo;

  toBeReplaced.forEach((el) => {
    errorMessage = errorMessage?.replace(el.out, el.in);
  });

  return errorMessage;
};

const handle503 = (
  router: Router,
  errorStateService: ErrorStateService,
  event: HttpErrorResponse,
) => {
  const errorMessage = errorMessageTransform(event.error);
  errorStateService.setError(errorMessage);
  return throwError(() => {
    setTimeout(() => {
      router.navigate([RoutingEnum.Disservice], {skipLocationChange: true});
    }, 0);
    return event;
  });
};

export class ErrorHandler {
  private errorStates: ErrorStates = {
    503: handle503,
  };

  constructor(
    private router: Router,
    private errorStateService: ErrorStateService,
  ) {}

  handleErrorStates = (event: HttpErrorResponse, destroy$: Subject<void>): any => {
    try {
      const errorStateRes = this.errorStates[event.status](
        this.router,
        this.errorStateService,
        event,
      );
      destroy$.next();
      destroy$.complete();
      return errorStateRes;
    } catch (error) {
      console.warn('Error state skipped from interceptor, status: ', event.status);
      return throwError(() => event);
    }
  };
}
